export * from './audio-player.component';
